export default __webpack_public_path__ + "static/media/img4.644698af.svg";